(() => {
  const materials = [
    ['ostrich', /ostrich/i], ['caiman', /caiman/i], ['crocodile', /crocodile|moreletii|\bcroc\b/i],
    ['alligator', /alligator/i], ['bison', /bison/i], ['buffalo', /buffalo/i],
    ['python', /python/i], ['stingray', /stingray/i], ['calfskin', /calfskin|calf\s*leather|\bcalf\b/i],
    ['cowhide', /cowhide/i], ['roughout', /roughout|rough out/i]
  ];
  const lower = value => String(value ?? '').toLocaleLowerCase().normalize('NFKD');
  function describe(product) {
    product.sizeIndex = product.options.findIndex(option => /size/i.test(option));
    product.widthIndex = product.options.findIndex(option => /^width$/i.test(option));
    const label = product.options[product.sizeIndex] || '';
    const width = label.match(/\(([BDE]+\s*\/\s*[BDE]+)/i)?.[1].replace(/\s/g, '').toUpperCase();
    const ambiguous = (width === 'D/E' && /\bEE\b/.test(product.description)) || (width === 'B/D' && /\bEE\b/.test(product.description));
    product.widths = product.mens ? ['D/EE'] : ambiguous ? [] : width ? [width] : [];
    const materialCopy = product.title + ' ' + product.description.split(/Our stock boots|This boot is dedicated|History of|We use no synthetic|Classic Round Toe|Heel is leather|Lux-calf interior/i)[0];
    product.materials = materials.filter(([, pattern]) => pattern.test(materialCopy)).map(([name]) => name);
    product.search = lower(product.title + ' ' + product.materials.join(' '));
    return product;
  }
  function matchingVariants(product, filters) {
    return product.variants.filter(variant => {
      if (filters.size && variant.options[product.sizeIndex] !== filters.size) return false;
      if (filters.width) {
        if (product.widthIndex >= 0) {
          if (variant.options[product.widthIndex] !== filters.width) return false;
        } else if (filters.width === 'confirm' ? product.widths.length : !product.widths.includes(filters.width)) return false;
      }
      if (filters.price && variant.price > Number(filters.price)) return false;
      if (filters.order_type === 'ready') return !product.made && variant.available && variant.inStock;
      if (filters.order_type === 'made') return product.made && variant.available;
      if (filters.order_type === 'backorder') return !product.made && variant.available && !variant.inStock;
      if (filters.size || filters.width) return variant.available;
      return true;
    });
  }
  function init(root) {
    if (root.dataset.ready) return;
    const form = root.querySelector('[data-shop-filters]');
    const strings = JSON.parse(root.querySelector('[data-shop-strings]').textContent);
    const cards = [...root.querySelectorAll('[data-shop-card]')].map((element, index) => ({ element, index, product: describe({...JSON.parse(element.querySelector('[data-shop-product]').textContent), mens: root.dataset.collection === 'republic-mens'}) }));
    const originalGrid = root.querySelector('[data-shop-grid]');
    const groups = [false, true].map(made => {
      const section = document.createElement('section');
      section.dataset.shopGroup = made ? 'made' : 'stock';
      const heading = document.createElement('h2');
      heading.textContent = made ? '1836 Made to Order' : '1836 Stock';
      heading.style.cssText = 'font-size:clamp(30px,3vw,44px);line-height:1.1;margin:0 0 10px;color:#0b303d';
      const description = document.createElement('p');
      description.textContent = made ? 'Made for your order. See each product for production and delivery details.' : 'Shop our stock collection. Select your size to check availability.';
      description.style.cssText = 'font-size:14px;line-height:1.5;margin:0 0 24px;max-width:650px';
      section.style.cssText = made ? 'margin-top:48px;padding-top:28px;border-top:2px solid #b68a52' : 'margin-top:24px';
      const grid = document.createElement('div');
      grid.className = 'rpl-shop-grid';
      section.append(heading, description, grid);
      originalGrid.before(section);
      return { made, section, grid };
    });
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: strings.currency || 'USD' }).format(amount / 100);
    const control = name => form.elements.namedItem(name);
    const populate = (name, values) => [...new Set(values)].filter(Boolean).sort((a,b) => a.localeCompare(b, undefined, { numeric: true })).forEach(value => control(name).add(new Option(value === 'confirm' ? strings.confirm : name === 'material' ? value.charAt(0).toUpperCase() + value.slice(1) : value.replace('/', ' / '), value)));
    populate('size', cards.flatMap(({product}) => product.variants.map(v => v.options[product.sizeIndex])));
    populate('width', cards.flatMap(({product}) => product.widthIndex >= 0 ? product.variants.map(v => v.options[product.widthIndex]) : product.widths.length ? product.widths : ['confirm']));
    populate('material', cards.flatMap(({product}) => product.materials));
    const parameters = new URL(location.href).searchParams;
    for (const name of ['style','order_type','size','width','material','price','sort']) {
      const value = parameters.get(name);
      if (value !== null && (name === 'style' || [...control(name).options].some(option => option.value === value))) control(name).value = value;
    }
    if (!parameters.has('order_type')) control('order_type').value = root.dataset.defaultOrder || 'all';
    function update(writeUrl = true) {
      const filters = Object.fromEntries(new FormData(form));
      const query = lower(filters.style).trim();
      let count = 0;
      for (const card of cards) {
        const p = card.product;
        card.matches = matchingVariants(p, filters);
        const visible = !!card.matches.length && (!query || query.split(/\s+/).every(word => p.search.includes(word))) && (!filters.material || p.materials.includes(filters.material));
        card.element.hidden = !visible;
        if (!visible) continue;
        count += 1;
        const available = card.matches.filter(v => v.available);
        card.sortPrice = Math.min(...card.matches.map(v => v.price));
        const varies = card.matches.some(v => v.price !== card.sortPrice);
        card.element.querySelector('[data-shop-price]').textContent = (varies ? strings.from + ' ' : '') + money(card.sortPrice);
        card.element.querySelector('[data-shop-badge]').textContent = p.made ? strings.made : available.some(v => v.inStock) ? strings.ready : available.length ? strings.backorder : strings.sold;
        const sizeText = filters.size ? strings.match.replace('[size]', filters.size) : '';
        card.element.querySelector('[data-shop-match]').textContent = sizeText;
        const selected = filters.size && available.length === 1 ? available[0] : null;
        const url = new URL(p.url, location.origin);
        if (selected) url.searchParams.set('variant', selected.id);
        card.element.querySelectorAll('a').forEach(anchor => anchor.href = url.pathname + url.search);
      }
      const sorted = [...cards].sort((a,b) => filters.sort === 'price_asc' ? (a.sortPrice ?? a.product.price) - (b.sortPrice ?? b.product.price) : filters.sort === 'price_desc' ? (b.sortPrice ?? b.product.price) - (a.sortPrice ?? a.product.price) : filters.sort === 'name' ? a.product.title.localeCompare(b.product.title) : a.index - b.index);
      groups.forEach(group => {
        const members = sorted.filter(card => card.product.made === group.made);
        members.forEach(card => group.grid.append(card.element));
        group.section.hidden = !members.some(card => !card.element.hidden);
      });
      originalGrid.hidden = true;
      root.querySelector('[data-shop-count]').textContent = strings.count.replace('[count]', count).replace('[total]', cards.length);
      root.querySelector('[data-shop-empty]').hidden = count !== 0;
      if (writeUrl) {
        const url = new URL(location.href);
        for (const [name,value] of Object.entries(filters)) {
          if (value && value !== 'all' && value !== 'featured') url.searchParams.set(name,value); else url.searchParams.delete(name);
        }
        history.replaceState(null,'',url);
      }
    }
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('change', () => update());
    control('style').addEventListener('input', () => update());
    form.addEventListener('reset', () => { requestAnimationFrame(() => { control('order_type').value='all'; update(); }); });
    root.querySelector('[data-shop-clear]').addEventListener('click', () => { form.reset(); control('style').focus(); });
    root.dataset.ready='true'; form.hidden=false; update(false);
  }
  document.querySelectorAll('[data-rpl-shop]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rpl-shop]').forEach(init));
})();

